import React from 'react'
import classes from './Buttons.module.css'
import PropTypes from 'prop-types';

const BtnSelect = ({ onClick, checked, children,dropStyle,dropClass }) => {
    return (<button className={`${classes.Btn} ${classes.SelectBtn} ${dropClass} ${checked ? classes.Checked : ''}`}
        onClick={onClick}
        style={dropStyle}>
        {children}
    </button>)
}

BtnSelect.propTypes = {
    onClick: PropTypes.func,
    dropStyle:PropTypes.object,
    checked: PropTypes.bool
}

export default BtnSelect;